import React from "react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import ReviewCarousel from "./reviewCrousel";

// Static testimonial data
const features = [
  {
    img: "/piyush.jpg",
    name: "Piyush Puri",
    pera: "This app has completely changed the way I manage my savings. I highly recommend this app to anyone who wants to transform their investment.",
  },
  {
    img: "/Jyoti.jpg",
    name: "Jyoti Tiwari",
    pera: "I was hesitant at first to buy digital gold, but this app made the process so simple and easy. The interface is user friendly and instructions are very clear. I now feel confident in my investment.",
  },
  {
    img: "/Minakshi.jpg",
    name: "Meenakshi Sharma",
    pera: "I recently invested in Gold and I would like to share my journey with you all. Bright DiGi Gold made my investment quick and easy. You can buy 24K pure gold with their safe and secure policies.",
  },
  {
    img: "/Nitin Gupta.jpg",
    name: "Nitin Gupta",
    pera: "I would like to share my hands-on experience with Bright DiGi Gold. I purchased 24k gold and I must say it has truly impressed me with its innovative approach to digital gold investment.",
  },
];

// Server-rendered wrapper
function ReviewWrapper({ children }: { children: React.ReactNode }) {
  return (
    <div className="bg-themeBlue">
      <div className="mx-auto px-4 sm:px-6 lg:px-16 py-8">
        <h1 className="text-center text-gray-800 text-3xl sm:text-5xl extrabold mb-12">
          Feedback
        </h1>
        {children}
      </div>
    </div>
  );
}

// Combine server and client parts
export default function Review() {
  return (
    <ReviewWrapper>
      <ReviewCarousel features={features} />
    </ReviewWrapper>
  );
}